/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Hero_H1_EmInputs */

const es_exp_mk_hero_h1_em = /** @type {(inputs: Exp_Mk_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gasto.`)
};

const gl_exp_mk_hero_h1_em = /** @type {(inputs: Exp_Mk_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gasto.`)
};

const en_exp_mk_hero_h1_em = /** @type {(inputs: Exp_Mk_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cost.`)
};

/**
* | output |
* | --- |
* | "cost." |
*
* @param {Exp_Mk_Hero_H1_EmInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_hero_h1_em = /** @type {((inputs?: Exp_Mk_Hero_H1_EmInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Hero_H1_EmInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_hero_h1_em(inputs)
	if (locale === "en") return en_exp_mk_hero_h1_em(inputs)
	return es_exp_mk_hero_h1_em(inputs)
});